const feedback = {
  submittime: "Submit time",
  processStatus: "Suggestion Status",
  feedbackStatusYes: "Feeback Yes",
  feedbackStatusNo: "Feeback No",
  suggestionDetail: "Suggestion Description",
  mobile: "Mobile Number",
  replayStatus: "Reply status",
  feedbackRepliedYes: "Feeback reply Yes",
  feedbackRepliedNo: "Feeback reply No",
  process: "Feedback Process",
  reply: "Reply",
  image1: "Image1",
  image2: "Image2",
  image3: "Image3",
  detail: "Reply content",
  title: "Feedback questions",
  questions: "Questions",
  search: {
    width1: "110px",
    width2: "120px",
    width3: "80px"
  },
  message1: "Please enter the content"
} 
export default feedback